import React from "react";
import { TabController } from "components/MainSearch/Components";
import { CaseTabType } from "components/MainSearch/Types";
import Case from "./Case";
import _ from "lodash";

/**
 * @description - Tab container for case result view.
 * @author Tharanga Niroshana <tharangan@unicorn-solutions.com>
 * @since 12/01/2025
 * */
export const CaseTab: React.FC<CaseTabType> = (props) => {
  const {
    isLoading,
    tabInfo,
    totalCaseSearchResult,
    isDataArchived,
    changeSortOrderEvent,
  } = props;
  const caseProps = _.omit(props, ["isLoading"]);

  return (
    <TabController
      isLoading={isLoading}
      isSortHidden={isDataArchived}
      changeSortOrderEvent={changeSortOrderEvent}
      tabInfo={tabInfo}
    >
      <Case {...caseProps} totalSearchResult={totalCaseSearchResult} />
    </TabController>
  );
};
